import {Headers, Http, RequestOptions} from "@angular/http";
import {Injectable} from "@angular/core";
import {ConfDataService} from "../conf-data.service";
import {environment} from "../../environments/environment";
import {LoaderUtils} from "./LoaderUtils";
import {ConfDataType} from "../conf-data-type";
import {AppLoadingStateService} from "../app-loading-state.service";
import {Router, UrlTree} from "@angular/router";

@Injectable()
export class ApiUtils {

    public static readonly TAG: string = "[ApiUtils]";

    constructor(
        private http: Http, 
        private router: Router, 
        private confDataService: ConfDataService, 
        private appLoadingStateService: AppLoadingStateService
    ) { }

    private getToken(): Promise<{ token: string; refresh_token: string; }> {

        console.log(ApiUtils.TAG, "Requesting Token ...");

        const urlWebService: string = environment.configurateur_url + "/login.php";
        const headers: Headers = new Headers();
        const options: RequestOptions = new RequestOptions({headers: headers});

        return this.http.get(urlWebService, options) // ...using post request
            .toPromise()
            .then(response => {
                    return response.json();
                }
            )
            .catch(err => {
                    LoaderUtils.hideLoader("contact-form-loader");
                    console.error(ApiUtils.TAG, "Something went wrong when requesting token !", err);
                }
            );
    }

    /**
     * API request for autocomplete fields.
     *
     * @param pRequestUrl
     * @param pCallback
     */
    public apiRequest(pRequestUrl: string, pCallback?: Function): void {

        this.getToken().then(json => {

            const headers: Headers = new Headers({"Authorization": "Bearer " + json.token});
            const options: RequestOptions = new RequestOptions({headers: headers});

            this.http.get(pRequestUrl, options) // ...using post request
                .map(res => res.json()) // ...and calling .json() on the response to return data
                .subscribe(
                    data => {
                        pCallback(data);
                    }
                );
        });

    }

    public saveDevis(): void {

        this.getToken().then(json => {

            if (json.token === undefined) {

                // TODO : Display error message on screen
                LoaderUtils.hideLoader("contact-form-loader");
                alert("TODO / Manage message error / Token Error / token is undefined");
                console.error(ApiUtils.TAG, "Token is undefined !", json);

            } else {

                const urlWebService: string = environment.api_configurateur_url + "/api/devis";
                const confdata: { [id: string]: ConfDataType } = this.confDataService.confdata;
                const headers: Headers = new Headers({"Authorization": "Bearer " + json.token});
                const options: RequestOptions = new RequestOptions({headers: headers});

                // Add config-token to update pumplastiques config if exist
                if(localStorage.getItem('authorized')) {
                    confdata["config-token"] = {
                        'id': "config-token",
                        'values': [{
                            "configToken" : localStorage.getItem('authorized')
                        }]
                    };
                }

                // Clean body
                let bodyString = {};
                for(let key in confdata) {
                    if(confdata[key].values) {
                        bodyString[key] = confdata[key];
                    }
                }

                this.http.post(urlWebService, bodyString, options) // ...using post request
                    .map(res => res.json()) // ...and calling .json() on the response to return data
                    .subscribe(
                        data => {
                            LoaderUtils.hideLoader("contact-form-loader");
                            if (data["code"] === 1) {

                                this.confDataService.updateElementValues("contact-form-valid", ["true"]);
                                this.confDataService.updateElementOptions("contact-form-valid", [{"date": new Date()}]);

                                LoaderUtils.hideLoader("contact-form-loader");

                                const urlTree: UrlTree = this.router.parseUrl(this.router.url);
                                const lang = urlTree.root.children.primary.segments[1].path;
                                const commands: string[] = ["/lang", lang, "contact-information", "end-of-study"];
                                this.router.navigate(commands);

                            } else {
                                // TODO : Display error message on screen
                                LoaderUtils.hideLoader("contact-form-loader");
                                alert("TODO / Manage message error / API Error / " + data["message"]);
                                console.error(ApiUtils.TAG, data["message"]);
                            }
                        },
                        err => {
                            // TODO : Display error message on screen
                            LoaderUtils.hideLoader("contact-form-loader");
                            alert("TODO / Manage message error / HTTP Error / " + err.toString());
                            console.error(ApiUtils.TAG, "Something went wrong while saving devis !", err);
                        }
                    );
            }
        });
    }

    public saveDraftDevis(): void {

        this.getToken().then(json => {

            if (json.token === undefined) {
                // TODO : Display error message on screen
                alert("TODO / Manage message error / Token Error / token is undefined");
                console.error(ApiUtils.TAG, "Token is undefined !", json);

            } else {

                const urlWebService: string = environment.api_configurateur_url + "/api/devis/draft";
                const headers: Headers = new Headers({"Authorization": "Bearer " + json.token});
                const confdata: { [id: string]: ConfDataType } = this.confDataService.confdata;
                const options: RequestOptions = new RequestOptions({headers: headers});

                // Add config-token to update pumplastiques config if exist
                if(localStorage.getItem('authorized')) {
                    confdata["config-token"] = {
                        'id': "config-token",
                        'values': [{
                            "configToken" : localStorage.getItem('authorized')
                        }]
                    };
                }

                // Clean body
                let bodyString = {};
                for(let key in confdata) {
                    if(confdata[key].values) {
                        bodyString[key] = confdata[key];
                    }
                }

                this.http.post(urlWebService, bodyString, options) // ...using post request
                    .map(res => res.json()) // ...and calling .json() on the response to return data
                    .subscribe(
                        data => {
                            LoaderUtils.hideLoader("draft-devis-loader");

                            if (data["code"] !== 1) {
                                alert("TODO / Manage message error / API Error / " + data["message"]);
                                console.error(ApiUtils.TAG, data["message"]);
                            }
                        },
                        err => {
                            // TODO : Display error message on screen
                            LoaderUtils.hideLoader("draft-devis-loader");
                            alert("TODO / Manage message error / HTTP Error / " + err.toString());
                            console.error(ApiUtils.TAG, "Something went wrong while saving devis !", err);
                        }
                    );
            }
        });
    }

    /**
     * Method that call api WS to load a devis (change localStorage values)
     */
    public loadDevisById() {

        const params = this.getSearchParameters();
        const devisId = params["devis"];

        if (devisId != null) {
            console.log(ApiUtils.TAG, "Loading Devis with id " + devisId + " ...");
            const url = environment.api_configurateur_url + "/api/devis/" + devisId + "/load";
            this.loadDevis(url, devisId);
        } else {
            this.appLoadingStateService.devisLoaded = true;
        }
    }

    /**
     * Load devis by a pumplastiques configuration's token
     */
    public loadDevisByConfigToken(configToken) {
        const url = environment.api_configurateur_url + "/api/pumplastiques/configuration/" + configToken + "/load";
        this.loadDevis(url, null, configToken);
    }

    private loadDevis(url, devisId = null, configToken = null) {
        this.getToken().then(json => {

            const headers: Headers = new Headers({"Authorization": "Bearer " + json.token});
            const options = new RequestOptions({headers: headers});

            // Get all infos about user
            this.http.get(url, options) // ...using post request
                .map(res => res.json()) // ...and calling .json() on the response to return data
                .subscribe(
                    jsonDevis => {

                        console.log(ApiUtils.TAG, jsonDevis.status);
                        console.log(ApiUtils.TAG, localStorage);

                        // Clear all local storage keys
                        this.confDataService.resetToDefault();
                        localStorage.clear();

                        if(jsonDevis.status && jsonDevis.status === 1) {
                            for (const key in jsonDevis.data) {
                                // skip loop if the property is from prototype
                                if (!jsonDevis.data.hasOwnProperty(key)) {
                                    continue;
                                }
                                localStorage.setItem(key, JSON.stringify(jsonDevis.data[key]));
                                if(key !== "id" && key !== "name" && key !== "createdAt" && key !== "contact-form") {
                                    localStorage.setItem(key + "-valid", '{"id":"'+ key +'-valid","values":["true"]}');
                                }
                                // console.log(ApiUtils.TAG, "Saving key " + key + " to localStorage ...", jsonDevis.data[key]);
                            }

                            if(devisId) {
                                console.log(ApiUtils.TAG, "Devis with id " + devisId + " successfully loaded !");
                            } else if(configToken) {
                                localStorage.setItem('authorized', configToken);
                                console.log(ApiUtils.TAG, "Pumplastiques configuration with token " + configToken + " successfully loaded !");
                            }

                            LoaderUtils.addLoader("app-load-devis", <HTMLElement>document.getElementsByTagName('app-root')[0], true);
                            setTimeout(() => {
                                window.location.href = environment.configurateur_url;
                            }, 150);
                        } else {
                            // throw new errors
                        }
                    },
                    err => {
                        if(devisId) {
                            console.warn(ApiUtils.TAG, "Something went wrong while loading devis with id " + devisId + "!", err);
                        } else if(configToken) {
                            console.warn(ApiUtils.TAG, "Something went wrong while loading pumplastiques configuration with token " + configToken + "!", err);
                        }
                        this.appLoadingStateService.devisLoaded = true;
                    }
                );
        });
    }

    /**
     * Method that call nicoll website WS to collect user information
     * and save them on localstorage to fill the contact form
     * @param environment
     * @param confDataService
     */
    public completeContactForm() {
        const params = this.getSearchParameters();
        const userId = params["user"];
        let user: string;

        if (userId != null) {

            // Generate url to complete contact form
            // with user info
            const url = environment.user_nicoll_url + userId + "?_format=json";
            const headers = new Headers();
            const options = new RequestOptions({headers: headers});

            // Get all infos about user
            this.http.get(url, options) // ...using post request
                .map(res => res.json()) // ...and calling .json() on the response to return data
                .subscribe(
                    data => {
                        // Get user data
                        user = data[0];

                        // Generate contact form JSON
                        const contactForm = [
                            {
                                "type_contact": user["field_type_de_contact"][0] ? user["field_type_de_contact"][0]["value"].toLowerCase() : "",
                                "categorie_pro": user["field_categorie_pro"][0] ? user["field_categorie_pro"][0]["value"].toLowerCase() : "",
                                "precision_autre_categorie": user["autre_categorie_professionnelle"][0] ? user["autre_categorie_professionnelle"][0]["value"] : "",
                                "civilite": user["field_civilite"][0] ? user["field_civilite"][0]["value"].toLowerCase() : "",
                                "lastname": user["nom"][0] ? user["nom"][0]["value"] : "",
                                "firstname": user["prenom"][0] ? user["prenom"][0]["value"] : "",
                                "phone": user["telephone"][0] ? user["telephone"][0]["value"] : "",
                                "email": user["name"][0]["value"],
                                "search_postcode": "",
                                "search_name_enterprise": "",
                                "siret": user["numero_siret"][0] ? user["numero_siret"][0]["value"] : "",
                                "name_enseigne": user["nom_societe"][0] ? user["nom_societe"][0]["value"] : "",
                                "raison_sociale": user["nom_societe"][0] ? user["nom_societe"][0]["value"] : "",
                                "address_principal_1": user["adresse_1"][0] ? user["adresse_1"][0]["value"] : "",
                                "address_principal_2": user["adresse_2"][0] ? user["adresse_2"][0]["value"] : "",
                                "address_principal_3": user["adresse_3"][0] ? user["adresse_3"][0]["value"] : "",
                                "address_principal_4": user["adresse_4"][0] ? user["adresse_4"][0]["value"] : "",
                                "address_principal_country": user["field_adresse_principale_pays"][0] ? user["field_adresse_principale_pays"][0]["value"] : "FR",
                                "address_principal_city": user["adresse_ville"][0] ? user["adresse_ville"][0]["value"] : "",
                                "address_principal_postcode": user["adresse_code_postal"][0] ? user["adresse_code_postal"][0]["value"] : "",
                                "created_date_ets": user["field_date_creation_etablissemen"][0] ? user["field_date_creation_etablissemen"][0]["value"] : "",
                                "code_ape_ets": user["code_ape_etablissement"][0] ? user["code_ape_etablissement"][0]["value"] : "",
                                "effectif_ets": user["field_etab_effec"][0] ? user["field_etab_effec"][0]["value"] : "",
                                "code_ape_ent": user["code_ape_entreprise"][0] ? user["code_ape_entreprise"][0]["value"] : "",
                                "effectif_ent": user["field_company_effec"][0] ? user["field_company_effec"][0]["value"] : "",
                                "type_societe": user["type_societe"][0] ? user["type_societe"][0]["value"] : "",
                                "libelle_ape_ent": user["libelle_ape_entreprise"][0] ? user["libelle_ape_entreprise"][0]["value"] : "",
                                "libelle_ape_ets": user["libelle_ape_etablissement"][0] ? user["libelle_ape_etablissement"][0]["value"] : "",
                                "capadresse_field_scqa": "",
                                "newsletter": user["abonnement_newsletter"][0] ? user["abonnement_newsletter"][0]["value"] : false
                            }
                        ];

                        // Save JSON
                        this.confDataService.updateElementValues("contact-form", contactForm);
                        // Fixme / Contact form fields are not update / Force reload to fill them !
                        window.location.href = window.location.href;
                    },
                    err => {
                        console.warn(ApiUtils.TAG, "Something went wrong while saving user info !");
                    }
                );
        } else {
            // get contact form
            let contactFormValue = this.confDataService.getElementValues("contact-form");

            // si vide initialise pays
            if(contactFormValue == undefined) {
                this.confDataService.updateElementValues("contact-form", [{
                    "address_principal_country": 'FR'
                }]);
                console.log("[ContactFormComponent] ", this.confDataService.confdata['contact-form']);
            }
        }
    }

    private getSearchParameters() {
        // Il y a un service Router ou ActivatedRoute qui sert à ça
        const prmstr = window.location.search.substr(1);
        return prmstr != null && prmstr !== "" ? this.transformToAssocArray(prmstr) : {};
    }

    private transformToAssocArray(prmstr) {
        const params = {};
        const prmarr = prmstr.split("&");
        for (let i = 0; i < prmarr.length; i++) {
            const tmparr = prmarr[i].split("=");
            params[tmparr[0]] = tmparr[1];
        }
        return params;
    }

}



// WEBPACK FOOTER //
// ./src/app/util/ApiUtils.ts